export default class UserTokenResponseParseError extends Error {
};
